import { TextField } from "@mui/material";
import { NumericFormat, NumberFormatValues } from "react-number-format";

type Props = {
  value: string;
  label?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
};

const TesSalaryTableDecimalInput = ({
  value,
  label,
  disabled,
  onChange,
}: Props) => (
  <NumericFormat
    customInput={TextField}
    fullWidth
    size="small"
    label={label}
    value={value}
    disabled={disabled}
    decimalSeparator=","
    valueIsNumericString
    decimalScale={2}
    allowNegative={false}
    onValueChange={(values: NumberFormatValues) => onChange(values.value)}
  />
);

export default TesSalaryTableDecimalInput;
